<template>
  <div>
    <b-modal
      ref="modal"
      scrollable
      size="xl"
      hide-footer
      hide-header
      body-class="modal-timeline-body"
    >
      <div class="modal-timeline">
        <Timeline
          variant="expanded"
          :conta-id="contaId"
          :conta-nome="contaNome"
          :lista="contaId ? null : lista"
          :cursor-inicial="contaId ? null : cursorInicial"
          @fechar="fechar"
          @evento:selecionado="selecionarEvento"
          @evento:ir="irPeloAtalho"
        >
          <template #lateral>
            <div v-if="!eventoSelecionado" class="modal-timeline__vazio">
              <i class="fas fa-hand-pointer"></i>
              <p>Selecione um evento na Timeline para ver os detalhes.</p>
            </div>

            <div v-else class="modal-timeline__detalhes">
              <h6 class="mb-4">Detalhes do evento</h6>

              <div class="modal-timeline__campo">
                <span class="modal-timeline__rotulo">Data/hora</span>
                <span>{{ dataCompleta(eventoSelecionado.data) }}</span>
              </div>

              <div class="modal-timeline__campo">
                <span class="modal-timeline__rotulo">Tipo</span>
                <span>{{ rotuloTipo(eventoSelecionado.tipo) }}</span>
              </div>

              <div class="modal-timeline__campo">
                <span class="modal-timeline__rotulo">{{
                  eventoSelecionado.tipo === "erro" ? "Erro" : "Modelo"
                }}</span>
                <span v-blur-sensitive>{{ eventoSelecionado.campanha }}</span>
              </div>

              <div class="modal-timeline__campo">
                <span class="modal-timeline__rotulo">Campanha</span>
                <span v-blur-sensitive>{{ eventoSelecionado.modelo }}</span>
              </div>

              <div class="modal-timeline__campo">
                <span class="modal-timeline__rotulo">Quantidade</span>
                <span>{{ eventoSelecionado.quantidade }}</span>
              </div>

              <div
                v-if="eventoSelecionado.qtd_enviado_erro > 0"
                class="modal-timeline__campo"
              >
                <span class="modal-timeline__rotulo">Envios com erro</span>
                <span>{{ eventoSelecionado.qtd_enviado_erro }}</span>
              </div>

              <template v-if="eventoSelecionado.tipo === 'erro'">
                <div
                  v-if="eventoSelecionado.motivo_erro"
                  class="modal-timeline__campo"
                >
                  <span class="modal-timeline__rotulo">Motivo</span>
                  <span>{{ eventoSelecionado.motivo_erro }}</span>
                </div>
                <div
                  v-if="eventoSelecionado.detalhes_erro"
                  class="modal-timeline__campo"
                >
                  <span class="modal-timeline__rotulo">Detalhes</span>
                  <span class="modal-timeline__detalhes-texto">{{
                    eventoSelecionado.detalhes_erro
                  }}</span>
                </div>
              </template>

              <div
                v-if="eventoSelecionado.agendada_id"
                class="modal-timeline__campo"
              >
                <span class="modal-timeline__rotulo">ID do agendamento</span>
                <span class="d-flex align-items-center">
                  {{ eventoSelecionado.agendada_id }}
                  <button
                    type="button"
                    class="modal-timeline__copiar"
                    title="Copiar"
                    @click="copiar(eventoSelecionado.agendada_id)"
                  >
                    <i class="fas fa-copy"></i>
                  </button>
                </span>
              </div>

              <!-- Os dois destinos lado a lado, cada um habilitado pela
            própria regra: campanha precisa do nome, relatório do id. Com
            contaId (Central de Contas, olhando outra conta) é preciso
            personificar antes de navegar. -->
              <div class="modal-timeline__acoes mt-4">
                <b-button
                  v-for="destino in DESTINOS_LISTA"
                  :key="destino.chave"
                  variant="primary"
                  size="sm"
                  :disabled="!temDestino(eventoSelecionado, destino.chave)"
                  :title="
                    temDestino(eventoSelecionado, destino.chave)
                      ? destino.titulo
                      : 'Este evento não tem dados para abrir este destino'
                  "
                  @click="irParaDestino(eventoSelecionado, destino.chave)"
                >
                  <i :class="['fas', destino.icone, 'mr-1']"></i>
                  {{ contaId ? destino.rotuloCurto : destino.rotulo }}
                </b-button>
              </div>
              <small v-if="!temAlgumDestino" class="modal-timeline__aviso">
                Evento sem campanha associada.
              </small>
              <small v-else-if="contaId" class="modal-timeline__aviso">
                Você será personificado na conta antes de navegar.
              </small>

              <b-button
                v-if="
                  eventoSelecionado.tipo === 'erro' &&
                  eventoSelecionado.agendada_id &&
                  !eventoSelecionado._reenviado
                "
                variant="warning"
                size="sm"
                class="mt-2 w-100"
                @click="reenviar(eventoSelecionado)"
              >
                Reenviar Mensagens Erro
              </b-button>
              <div v-else-if="eventoSelecionado._reenviado" class="mt-4">
                <small class="text-success"
                  ><i class="fas fa-check mr-1"></i>Reenviado</small
                >
              </div>
            </div>
          </template>
        </Timeline>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";
import API_LINKS from "../../automacao/api.links";
import Timeline from "../../dashboard/Timeline.vue";
import {
  DESTINOS,
  temDestino,
  urlDestino
} from "../../dashboard/timelineDestinos";

const ROTULOS_TIPO = {
  envio: "Envio",
  recebimento: "Resposta",
  erro: "Erro",
  agendamento: "Agendado"
};

export default {
  components: { Timeline },
  props: {
    lista: {
      type: Array,
      default: null
    },
    cursorInicial: {
      default: null
    }
  },
  data() {
    return {
      contaId: null,
      contaNome: "",
      eventoSelecionado: null,
      DESTINOS_LISTA: [DESTINOS.campanha, DESTINOS.relatorio]
    };
  },
  computed: {
    temAlgumDestino() {
      return this.DESTINOS_LISTA.some((d) =>
        temDestino(this.eventoSelecionado, d.chave)
      );
    }
  },
  methods: {
    temDestino,

    // contaId nulo = timeline da propria conta logada (usado na Home, ao
    // expandir); com contaId, e a timeline daquela conta (Central de Contas).
    abrir(contaId = null, contaNome = "") {
      this.contaId = contaId;
      this.contaNome = contaNome || "";
      this.eventoSelecionado = null;
      this.$nextTick(() => {
        this.$refs.modal.show();
      });
    },

    fechar() {
      this.$refs.modal.hide();
    },

    selecionarEvento(evento) {
      this.eventoSelecionado = evento;
    },

    // Vem do atalho de ícone dentro do card da Timeline: o componente não
    // navega sozinho quando há contaId, justamente pra passar por aqui.
    irPeloAtalho({ evento, destino }) {
      this.eventoSelecionado = evento;
      this.irParaDestino(evento, destino);
    },

    irParaDestino(evento, destino) {
      if (!temDestino(evento, destino)) return;

      const url = urlDestino(evento, destino);

      // Na própria conta é navegação direta.
      if (!this.contaId) {
        this.$router.push(url);
        return;
      }

      Swal.fire({
        title: "Personificar e ir?",
        html: `Você entrará na conta <strong>${
          this.contaNome
        }</strong> e será levado para ${
          destino === "campanha" ? "a campanha" : "o relatório"
        }.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#472282",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, personificar",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (!result.value) return;

        Swal.fire({
          title: "Trocando de conta...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        ApiService.post("/usuario/trocar-conta", { contaId: this.contaId })
          .then(() => {
            // Reload duro para a rota de destino: a troca de conta reinicia
            // a sessão, então não dá pra usar router.push aqui.
            window.location.href = url;
          })
          .catch(() => {
            Swal.fire(
              "Erro",
              "Não foi possível trocar de conta. Tente novamente.",
              "error"
            );
          });
      });
    },

    rotuloTipo(tipo) {
      return ROTULOS_TIPO[tipo] || tipo;
    },

    dataCompleta(data) {
      return moment(data).format("DD/MM/YYYY [às] HH:mm");
    },

    copiar(valor) {
      navigator.clipboard.writeText(String(valor));
    },

    reenviar(evento) {
      Swal.fire({
        title: "Deseja tentar novamente?",
        text: "A campanha será enviada novamente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, tentar novamente!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.value) {
          ApiService.post(API_LINKS.campanha + "/tentar-novamente", {
            agendada_id: evento.agendada_id
          }).then(() => {
            this.$set(evento, "_reenviado", true);
            Swal.fire(
              "Tentativa realizada!",
              "A campanha foi enviada novamente.",
              "success"
            );
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
// body-class do b-modal — não fica escopado ao componente.
.modal-timeline-body {
  padding: 0 !important;
}
</style>

<style scoped lang="scss">
.modal-timeline__conta {
  padding: 0.85rem 1.5rem;
  border-bottom: 1px solid #ebedf3;
  color: #7c7c8a;
  font-size: 0.85rem;
  font-weight: 600;
}

// O Timeline ocupa o modal inteiro; a divisao lista/detalhes acontece
// dentro dele (slot lateral), pra que o cabecalho fique de fora a fora.
.modal-timeline {
  display: flex;
  height: 75vh;

  > * {
    flex: 1 1 auto;
    min-width: 0;
  }
}

.modal-timeline__vazio {
  height: 100%;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #b5b5c3;
  text-align: center;

  i {
    font-size: 2rem;
    margin-bottom: 0.75rem;
  }
}

.modal-timeline__detalhes {
  padding: 1.5rem;
}

.modal-timeline__acoes {
  display: flex;
  gap: 0.5rem;

  > * {
    flex: 1 1 0;
    min-width: 0;
  }
}

.modal-timeline__aviso {
  display: block;
  margin-top: 0.4rem;
  text-align: center;
  color: #b5b5c3;
}

.modal-timeline__campo {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f3f6f9;
}

.modal-timeline__rotulo {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #b5b5c3;
  letter-spacing: 0.03em;
}

.modal-timeline__detalhes-texto {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.85rem;
}

.modal-timeline__copiar {
  border: none;
  background: none;
  color: #b5b5c3;
  margin-left: 0.5rem;
  cursor: pointer;

  &:hover {
    color: #472282;
  }
}
</style>
